import { format } from 'd3-format';

import { SankeyRenderConfig } from './types';

type NumberStyle = SankeyRenderConfig['numberStyle'];
type NumberStyleMarks = NumberStyle['marks'];

// updateMarks: given a US-formatted number string, replace with user's
// preferred separators:
function updateMarks(stringIn: string, numberMarks: NumberStyleMarks) {
  // If the digit-group mark is a comma, implicitly the decimal is a dot...
  // That's what we were given, so return:
  if (numberMarks.group === ',') {
    return stringIn;
  }

  // Perform hacky mark swap using ! as a placeholder:
  return stringIn
    .replaceAll(',', '!')
    .replaceAll('.', numberMarks.decimal)
    .replaceAll('!', numberMarks.group);
}

// formatDecimals: produce a value in the user's designated decimal format:
export function formatDecimals(numberIn: number, nStyle: NumberStyle) {
  return updateMarks(
    format(`,.${nStyle.decimalPlaces}${nStyle.trimString}f`)(numberIn),
    nStyle.marks
  );
}

// formatWithPreAndSuffix: produce a value in the user's designated format:
export function formatWithPreAndSuffix(numberIn: number, nStyle: NumberStyle) {
  const nString = formatDecimals(numberIn, nStyle);
  return `${nStyle.prefix}${nString}${nStyle.suffix}`;
}
